import React from 'react'
// libs
import { useMutation } from '@apollo/client/react'
// context
import { PlanTypesPageContext } from 'containers/PlanTypes/layers/API'
// hooks
import { useModalData } from 'hooks'
// graphql
import { PLAN_TYPE_CREATE_MUTATION } from 'graphql/planType/mutations'
// components
import { DrawerModal } from 'components/UI'
import Header from 'components/UI/Modal/Header'
import PlanTypeCreateForm from './PlanTypeCreateForm'
// constants
import { Modals } from 'constants/modals'
// utils
import { toSubmissionError } from 'utils/errors/form'
import { getValueFromOption } from 'utils/form'

const PAPER_PROPS = {
  style: {
    overflow: 'hidden'
  }
}

const PlanTypeCreateModal = () => {
  const [createPlanType] = useMutation(PLAN_TYPE_CREATE_MUTATION)

  const {
    modalData: { isOpen },
    hideModal
  } = useModalData({ modalType: Modals.PLAN_TYPE_CREATE_MODAL })

  const { refetch } = React.useContext(PlanTypesPageContext)

  const handleFormSubmit = async (data) => {
    try {
      await createPlanType({
        variables: {
          planType: {
            code: data.code,
            description: data.description,
            objectiveOwnerObjectSecurityId: getValueFromOption(data.objectiveOwnerObjectSecurity),
            objectiveMemberObjectSecurityId: getValueFromOption(data.objectiveMemberObjectSecurity),
            actionOwnerObjectSecurityId: getValueFromOption(data.actionOwnerObjectSecurity),
            actionMemberObjectSecurityId: getValueFromOption(data.actionMemberObjectSecurity),
            kpiOwnerObjectSecurityId: getValueFromOption(data.kpiOwnerObjectSecurity),
            kpiMemberObjectSecurityId: getValueFromOption(data.kpiMemberObjectSecurity),
            planOwnerObjectSecurityId: getValueFromOption(data.planOwnerObjectSecurity),
            planMemberObjectSecurityId: getValueFromOption(data.planMemberObjectSecurity)
          }
        }
      })

      await refetch()
      hideModal()
    } catch (errors) {
      throw toSubmissionError(errors)
    }
  }

  return (
    <DrawerModal width={'500px'} isOpen={isOpen} hideModal={hideModal} PaperProps={PAPER_PROPS}>
      <Header handleClearClick={hideModal}>Create Plan Type</Header>
      <PlanTypeCreateForm onSubmit={handleFormSubmit} handleCancelClick={hideModal} />
    </DrawerModal>
  )
}

export default PlanTypeCreateModal
